import { __extends } from "tslib";
import { ListBucketInventoryConfigurationsOutput, ListBucketInventoryConfigurationsRequest } from "../models/index";
import { deserializeAws_restXmlListBucketInventoryConfigurationsCommand, serializeAws_restXmlListBucketInventoryConfigurationsCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListBucketInventoryConfigurationsCommand = /** @class */ (function (_super) {
    __extends(ListBucketInventoryConfigurationsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListBucketInventoryConfigurationsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListBucketInventoryConfigurationsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: ListBucketInventoryConfigurationsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListBucketInventoryConfigurationsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListBucketInventoryConfigurationsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlListBucketInventoryConfigurationsCommand(input, context);
    };
    ListBucketInventoryConfigurationsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlListBucketInventoryConfigurationsCommand(output, context);
    };
    return ListBucketInventoryConfigurationsCommand;
}($Command));
export { ListBucketInventoryConfigurationsCommand };
//# sourceMappingURL=ListBucketInventoryConfigurationsCommand.js.map